import React from "react";
import {PlusCircleOutlined, MinusCircleOutlined} from "@ant-design/icons";
import {RepeatableActionsProps} from "@data-force/app";
import {connect} from "react-redux";
import {message} from "antd";
import {ENTER_KEY, SPACE_KEY} from "../../../utils/constants";
import {clearAlerts} from "../../../store/actions/layout";
import {ClearAlertsAction} from "../../../interfaces/store/actions/layout";

interface DispatchProps {
    clearAlerts(): ClearAlertsAction
}

export type Props = RepeatableActionsProps & DispatchProps;

class RepeatableActions extends React.Component<Props> {
    constructor(props: Props) {
        super(props);

        this.addField = this.addField.bind(this);
        this.removeField = this.removeField.bind(this);
        this.onAddField = this.onAddField.bind(this);
        this.onRemoveField = this.onRemoveField.bind(this);
    }

    /**
     * Add repeatable field
     *
     * @param {React.KeyboardEvent} event
     * @return {void}
     */
    onAddField(event: React.KeyboardEvent): void {
        if ([ENTER_KEY, SPACE_KEY].includes(event.key)) {
            this.addField();
        }
    }

    /**
     * Remove repeatable field
     *
     * @param {React.KeyboardEvent} event
     * @return {void}
     */
    onRemoveField(event: React.KeyboardEvent): void {
        if ([ENTER_KEY, SPACE_KEY].includes(event.key)) {
            this.removeField();
        }
    }

    addField(): void {
        const {
            addRepeatableField, defaultValue, readOnly, fieldName, index, onSave,
        }: RepeatableActionsProps = this.props;

        if (!readOnly) {
            addRepeatableField(fieldName, index, defaultValue);

            if (onSave) {
                onSave({
                    fieldName,
                    index,
                    changeValue: undefined,
                });
            }
            message.destroy();
            this.props.clearAlerts();
        }
    }

    removeField(): void {
        const {
            removeRepeatableField, readOnly, fieldName, index, onSave,
        }: RepeatableActionsProps = this.props;

        if (!readOnly) {
            removeRepeatableField(fieldName, index);

            if (onSave) {
                onSave({
                    fieldName,
                    index,
                    changeValue: undefined,
                });
            }
            message.destroy();
            this.props.clearAlerts();
        }
    }

    render() {
        const {removeVisible, readOnly}: RepeatableActionsProps = this.props;
        const actionClass = `multi-turn-icon ${readOnly ? "df-icon-read-only" : ""}`;

        return (
            <>
                <PlusCircleOutlined
                    className={actionClass}
                    onClick={this.addField}
                    tabIndex={0}
                    onKeyDown={this.onAddField}
                />
                {removeVisible && (
                    <MinusCircleOutlined
                        className={actionClass}
                        onClick={this.removeField}
                        tabIndex={0}
                        onKeyDown={this.onRemoveField}
                    />
                )}
            </>
        );
    }
}

const mapDispatchToProps: DispatchProps = {
    clearAlerts,
};

export default connect(null, mapDispatchToProps)(RepeatableActions);
